__turbopack_context__.v({
  "grid": "day-wiki-module__DoeVWq__grid",
  "preview": "day-wiki-module__DoeVWq__preview",
  "previewImage": "day-wiki-module__DoeVWq__previewImage",
  "tile": "day-wiki-module__DoeVWq__tile",
});
